import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/atul/WORK/MLH/react-components/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Select from './Select.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "select"
    }}>{`Select`}</h1>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Select\n  ui={{\n    size: { h: \'40\', w: \'130\' },\n    color: { val: \'#1fa3b8\', bg: \'white\' },\n    border: { w: \'1\', style: \'solid\', color: \'#1fa3b8\', r: \'5\' },\n    margin: { l: \'20\', t: \'20\' },\n    options: [\'select 1\', \'select 2\'],\n  }}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Select,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <Select ui={{
        size: {
          h: '40',
          w: '130'
        },
        color: {
          val: '#1fa3b8',
          bg: 'white'
        },
        border: {
          w: '1',
          style: 'solid',
          color: '#1fa3b8',
          r: '5'
        },
        margin: {
          l: '20',
          t: '20'
        },
        options: ['select 1', 'select 2']
      }} mdxType="Select" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      